var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-items-center flex-shrink-0"},[_c('UserDropdown'),_c('NotificationDropdown',{attrs:{"reload":_vm.reload},on:{"reset":_vm.reset,"showNotifier":_vm.showNotifier}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }